module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('strong', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226432212_07_Ack#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226432212_08_Int#int"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-authora"
  }, [_vm._v("Daniel P. Kessler")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226432212_09_Ch1#ch1"
    }
  }, [_c('strong', [_vm._v("1. Regulation (Agencies) versus Litigation (Courts): An Analytical Framework")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-author"
  }, [_vm._v("Richard A. Posner")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226432212_10_Ch2#ch2"
    }
  }, [_c('strong', [_vm._v("2. Efficient Regulation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-author"
  }, [_vm._v("Andrei Shleifer")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226432212_11_Ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3. The Trouble with Cases")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-author"
  }, [_vm._v("Frederick Schauer and Richard Zeckhauser")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226432212_12_Ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4. Tobacco Regulation through Litigation: The Master Settlement Agreement")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-author"
  }, [_vm._v("W. Kip Viscusi and Joni Hersch")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226432212_13_Ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5. Gun Control after "), _c('em', [_vm._v("Heller")]), _vm._v(": Litigating against Regulation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-author"
  }, [_vm._v("Philip J. Cook, Jens Ludwig, and Adam Samaha")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226432212_14_Ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6. The Effects of Product Liability Exemption in the Presence of the FDA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-author"
  }, [_vm._v("Tomas J. Philipson, Eric Sun, and Dana Goldman")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226432212_15_Ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7. The Impact of Employment Protection on Workers Disabled by Workplace Injuries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-author"
  }, [_vm._v("Adam H. Gailey and Seth A. Seabury")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226432212_16_Ch8#ch8",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8. Opting Out of Workers’ Compensation in Texas: A Survey of Large, Multistate Nonsubscribers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-author"
  }, [_vm._v("Alison Morantz")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226432212_17_Ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9. M&A Break Fees: U.S. Litigation versus UK Regulation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-author"
  }, [_vm._v("John C. Coates IV")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226432212_18_Ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10. Exploring Ex Ante Regulatory Mechanisms for Detecting Prescription Drug Misuse")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-author"
  }, [_vm._v("Stephen T. Parente")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226432212_19_Ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11. Natural Disaster Management: Earthquake Risk and Hospitals’ Provision of Essential Services in California")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-authora"
  }, [_vm._v("Tom Chang and Mireille Jacobson")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226432212_21_Con#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226432212_22_Ind1#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226432212_23_Ind2#ind1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee34950","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780226432212_06_Toc.vue
// module id = 72
// module chunks = 0